export function isAiIdTemporary(id: string): boolean {
  return id.includes('newAi_');
}
